var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup534Red(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.075,
    height: 40,
    viewBox: "0 0 40.075 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534",
    transform: "translate(627.147 -185.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3434",
    "data-name": "Path 3434",
    d: "M-618.906,265.192a9.41,9.41,0,0,1-.014-13.6,9.311,9.311,0,0,1,12.9.005,9.413,9.413,0,0,1-.009,13.586,15.163,15.163,0,0,1,5.986,5.4,14.569,14.569,0,0,1,2.255,7.753h-29.359a14.233,14.233,0,0,1,2.2-7.693A14.929,14.929,0,0,1-618.906,265.192Zm-5.3,10.487h23.468a12.125,12.125,0,0,0-7.711-8.6,1.44,1.44,0,0,0-.875.086,9.59,9.59,0,0,1-6.288.005,1.453,1.453,0,0,0-.875-.1A12.088,12.088,0,0,0-624.2,275.679Zm11.755-10.643a6.693,6.693,0,0,0,6.655-6.705,6.691,6.691,0,0,0-6.705-6.653,6.689,6.689,0,0,0-6.653,6.7A6.693,6.693,0,0,0-612.449,265.036Z",
    transform: "translate(0 -53.201)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3435",
    "data-name": "Path 3435",
    d: "M-519.4,203.684l-.618-2.56a6.819,6.819,0,0,0,5.219-3.544,6.212,6.212,0,0,0,.719-4.027,6.693,6.693,0,0,0-6.124-5.75c-3.534-.214-5.849,1.7-7.178,5.98l-2.395-.57c-.284-1.939,1.916-5.849,5.317-7.3a9.367,9.367,0,0,1,11.261,2.977,9.406,9.406,0,0,1-1.038,12.39,14.9,14.9,0,0,1,8.262,13.161c-.3.023-.514.054-.728.054-3.449,0-6.9.016-10.346-.019a1.808,1.808,0,0,1-1.041-.468c-.728-.627-1.4-1.321-2.272-2.163h11.392a12.147,12.147,0,0,0-5.879-7.838c-1.134-.666-2.269-1.139-3.59-.506A3.76,3.76,0,0,1-519.4,203.684Z",
    transform: "translate(-81.1 0)",
    fill: "#d10a11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup534Red);
export default __webpack_public_path__ + "static/media/Group 534 red.cbbe10ca80e9d71013e161026186c103.svg";
export { ForwardRef as ReactComponent };